const install = function (Vue) {
  const Bus = new Vue({
    methods: {
      emit(event, ...args) {
        this.$emit(event, ...args);
      },
      on(event, callback) {
        this.$on(event, callback);
      },
      off(event, callback) {
        this.$off(event, callback);
      }
    }
  });
  Vue.prototype.$EventBus = Bus;
};
export default install;


//////////////////
// WEBPACK FOOTER
// ./event-bus.js
// module id = null
// module chunks = 